import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Grid2, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import GroupIcon from '@mui/icons-material/Group';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { Page, Header } from 'components';
import Card from './components/Card/Card.js';
import UsersDataTable from './components/UsersDataTable/UsersDataTable.js';
import AddEditUsersDialog from './components/AddEditUserDialog/AddEditUserDialog.js';
import AddPedingUsersDialog from './components/AddPendingUsersDialog/AddPendingUsersDialog.js';
import DeleteUsersDialog from './components/DeleteUserDialog/DeleteUserDialog';
import { SetInitialState, GetUsers, GetPendingUsers, GetUsersStats, ToggleAddEditUserDialog, ToggleAddPendingUsersDialog, ToggleDeleteUserDialog } from '../../actions/UsersActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
}));

const Users = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const user = useSelector((state) => state.session.user);
	const usersStats = useSelector((state) => state.usersReducer.usersStats);
	const users = useSelector((state) => state.usersReducer.users);
	const openAddEditUserDialog = useSelector((state) => state.usersReducer.openAddEditUserDialog);
	const openAddPendingUsersDialog = useSelector((state) => state.usersReducer.openAddPendingUsersDialog);
	const openDeleteUserDialog = useSelector((state) => state.usersReducer.openDeleteUserDialog);
	const pendingUsers = useSelector((state) => state.usersReducer.pendingUsers);

	const _addEditUserClose = () => {
		dispatch(ToggleAddEditUserDialog(false));
	};

	const _addPendingUsersClose = () => {
		dispatch(ToggleAddPendingUsersDialog(false));
	};

	const _deleteUserClose = () => {
		dispatch(ToggleDeleteUserDialog(false));
	};

	const _addUser = () => {
		dispatch(SetInitialState());
		dispatch(ToggleAddEditUserDialog(true));
	};

	const _addPendingUsers = () => {
		dispatch(ToggleAddPendingUsersDialog(true));
	};

	const _renderActions = () => (
		<div>
			<Button color="primary" variant="contained" onClick={_addUser}>
				<AddIcon />
				Add
			</Button>
			<Button style={{ marginLeft: '10px' }} color="warning" variant="contained" onClick={_addPendingUsers} disabled={!pendingUsers.length > 0}>
				<AddIcon />
				Pending
			</Button>
		</div>
	);

	const getData = useCallback(() => {
		dispatch(GetUsers(user.role));
		dispatch(GetUsersStats());
		dispatch(GetPendingUsers());
	}, []);

	useEffect(() => {
		getData();
	}, [getData]);

	return (
		<Page className={classes.root} title="Users">
			<Header module="Management" view="Users" actions={_renderActions()} />
			<Grid2 className={classes.container} container spacing={3}>
				<Grid2 item size={3}>
					<Card title="online" text={usersStats.online} />
				</Grid2>
				<Grid2 item size={3}>
					<Card title="active" text={usersStats.active} icon={<GroupIcon />} />
				</Grid2>
				<Grid2 item size={3}>
					<Card title="client" text={usersStats.client} icon={<BusinessCenterIcon />} />
				</Grid2>
				<Grid2 item size={3}>
					<Card title="registered" text={usersStats.registered} icon={<AssignmentTurnedInIcon />} />
				</Grid2>
				<Grid2 item size={12}>
					<UsersDataTable className={classes.results} data={users} user={user} />
				</Grid2>
			</Grid2>
			{openAddEditUserDialog && (
				<AddEditUsersDialog
					onClose={_addEditUserClose}
					open={openAddEditUserDialog}
					user={user}
				/>
			)}
			{openAddPendingUsersDialog && (
				<AddPedingUsersDialog
					onClose={_addPendingUsersClose}
					open={openAddPendingUsersDialog}
				/>
			)}
			{openDeleteUserDialog && (
				<DeleteUsersDialog
					onClose={_deleteUserClose}
					open={openDeleteUserDialog}
					user={user}
				/>
			)}
		</Page>

	);
};

export default Users;
